import { Center, Icon } from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';

interface Properties {
  isChecked: boolean;
  boxSize?: string;
}

const CustomCheckboxIcon = ({ isChecked, boxSize = '10px' }: Properties) => {
  return (
    <Center w='14px' h='10px' bg='transparent'>
      {!isChecked ? null : <Icon as={CheckIcon} color='black' boxSize={boxSize} />}
    </Center>
  );
};

export default CustomCheckboxIcon;
